import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../api/api";
import functions from '../../functions';
import {TabContent, TabPane, Nav, NavItem, NavLink, Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

class Modal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            id: null,
            codigo: "",
            descripcion: "",
            cod_equivalente: "",
            cod_barra: "",
            stocks: [],
            precios: [],
            postVariables: [],
        };
    }

    static propTypes = {
        lista_code: PropTypes.string.isRequired,
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE']).isRequired,
    }

    resetForm() {
        this.setState({
            codigo: "",
            descripcion: "",
            cod_equivalente: "",
            cod_barra: "",
            stocks: [],
            precios: [],
        });
    }

    getData() {
        const { postVariables} = this.state;
        let data = {};

        postVariables.forEach(x => {
            if(this.state[x] != null){
             data[x] = this.state[x];
            }
        });
        return data;
    }

    setData(data) {
        if (data.success) {
            this.setState({
                id: data.Codigo,
                codigo: data.Codigo,
                descripcion: data.Titulo,
                cod_equivalente: data.CodEquivalente != null && data.CodEquivalente.length > 0 ? data.CodEquivalente : "No Posee",
                cod_barra: data.CodBarra != null && data.CodBarra.length > 0 ? data.CodBarra : "No Posee",
                stocks: data.stocks_nombre,
                precios: data.precios_en_lista,
            })
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {
        const { action } = this.props;
        if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                title: "Detalle",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: this.props.id,
            };
        }
    }

    render() {
        let vars = this.modalVars();
        const md_firstCol = 3;
        return (
            <ParadigmaModal
                getUrl={(vars.get ? `${api.consultador.detail}/${this.props.lista_code}/` : null)}
                submitUrl={(vars.submitType ? api.consultador.detail : null)}
                submitType={vars.submitType}
                id={vars.id}

                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                closeButton={true}
                className="modal-tabs modal-lg"
            >
            <h4 className="col-separator"><strong>({this.state.codigo}) {this.state.descripcion}</strong></h4>
            <Row>
            <Col md={md_firstCol}>Cód. Equivalente</Col>
            <Col>{this.state.cod_equivalente}</Col>
            <Col md={md_firstCol}>Cód. Barras</Col>
            <Col>{this.state.cod_barra}</Col>
            </Row>
            <Row><Col xs={12} className="col-separator my-2 py-1 ml-md-1">Precios</Col></Row>
            <Row>
            {
                 this.state.precios.map((precio, index) => (
                      <Col key={`precio-${index}`} xs={4}>
                      <Row>
                      <Col>{precio.nombre}</Col>
                      <Col className="text-nowrap"><strong>{`$ ${functions.FormatPrice(precio.valor && precio.valor > 0 ? precio.valor: 0)}`}</strong></Col>
                      </Row>
                      </Col>
                 ))
            }
            </Row>
            <Row><Col xs={12} className="col-separator my-2 py-1 ml-md-1">Stock</Col></Row>
            <Row>
            {
                 this.state.stocks.map((stock, index) => (
                      <Col key={`stocks-${index}`} xs={4}>
                      <Row>
                      <Col xs={8} className="mx-0">{stock.deposito}</Col>
                      <Col className="mx-1">{stock.cantidad}</Col>
                      </Row>
                      </Col>
                 ))
            }
            </Row>
            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/ConsultadorArticulos/Modal.js